import { Outlet } from "react-router-dom"
import { LoggedOutFooter } from "~/footers/logged-out-footer"
import LoggedOutHeader from "~/headers/logged-out-header"

/**
 * doesn't incldue navigation etc, intended mostly for pages where the user is not logged in
 */
export const MinimalLayout = () => {
  return (
    <div className="flex min-h-screen flex-col">
      <LoggedOutHeader />

      <main className="flex flex-1 flex-col overflow-y-auto p-4">
        <div className="mx-auto flex w-full max-w-7xl flex-1 flex-col px-4">
          <Outlet />
        </div>
      </main>

      <LoggedOutFooter className="mx-auto px-4" />
    </div>
  )
}
